<template>
  <div class="banner">
    <v-button class="play-game" :arrow="true" v-scroll-to="'#section4-top'">
      Speel de game!
    </v-button>
    <div>
      <arrow-button direction="down" v-scroll-to="'#section1'" />
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button.vue'
import ArrowButton from '@/components/home/ArrowButton.vue'

export default {
  name: 'Banner',
  components: {
    ArrowButton,
    'v-button': Button
  }
}
</script>

<style scoped lang="scss">
.banner {
  position: relative;
  height: 48rem;
  margin-top: 6.0rem;
  background-image: url('~@/assets/images/splash.jpg');
  background-size: cover;
  background-position: 75% 25%;

  .play-game {
    position: absolute;
    left: 9rem;
    top: 60%;
  }

  div {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 3rem);
  }

  button {
    background-color: $color-green;

    &:hover {
      background-color: lighten($color-green, 5%);
    }
  }
}
</style>
